<script lang="ts" setup>
  import type * as CSS from 'csstype'

  defineProps<{
    backgroundColor?: CSS.Property.BackgroundColor
  }>()
</script>

<template>
  <div class="c-group-booking-chope">
    <client-only>
      <!-- eslint-disable-next-line vuejs-accessibility/iframe-has-title -->
      <iframe
        align="middle"
        frameborder="no"
        height="800px"
        name="frame1"
        scrolling="auto"
        src="https://bookv5.chope.co/booking?rid=grilldbali2001bal&source=rest_grilld.com"
        width="400px"
      />
    </client-only>
  </div>
</template>

<style lang="scss" scoped>
  .c-group-booking-chope {
    display: flex;
    flex-direction: column;
    align-items: center;

    min-height: 800px;

    background-color: v-bind(backgroundColor);
  }
</style>
